import React from 'react';
import {isEnglish} from "../../component/const/Function";
import {REST_URL} from "../../component/const/Const";

export const DeleteDataTable = ({data}) => {
    if (!data || data.length === 0) return <h1 className={`text-4xl font-bold text-center`}>loading....</h1>;
    // 첫번째 객체의 key 목록에서 'age' 필드를 제외
    const headers = Object.keys(data[0]).filter((key) => !isEnglish(key));
    const remove = (id) => {
        fetch(REST_URL + '/activity_test_template?id=eq.' + id.toString(), {
            method: "DELETE"
        }).then(() => window.location.reload());
    }
    return (
        <div className="overflow-x-auto p-4 [&_tr]:">
            <table className="min-w-full table-auto border border-gray-200">
                <thead className="bg-gray-100">
                <tr>
                    {headers.map((header) => (
                        <th key={header} className="px-4 py-4 border text-xl"
                            dangerouslySetInnerHTML={{__html: header}}
                        />
                    ))}
                    <th className="px-4 py-4 border text-xl">삭제</th>
                </tr>
                </thead>
                <tbody>
                {data.map((item, idx) => (
                    <tr key={idx}>
                        {headers.map((header) => (
                            <td className="px-4 py-4 border text-xl" key={`${header}${idx}`}
                                dangerouslySetInnerHTML={{__html: item[header] !== null ? item[header].toString() : ''}}
                            />
                        ))}
                        <td className="px-4 py-4 border text-xl">
                            <button onClick={() => remove(item.id)}>삭제</button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};
